module.exports = __webpack_public_path__ + "static/media/virus_ai_cover.c4c422bf.svg";